import { genreMatchesFilter, removeNulls } from '@trqk/utils';

import { calculateTrackSplits } from '.';

const getChartTracksPerGenreBucket = (
    chartTracks: ProChartTrackWrapper | null,
    chartTrackKind: 'digital' | 'nondigital',
): ChartTrackPerGenreBucket[] => {
    const tracks: ProChartTrack[] = removeNulls(
        chartTracks?.[chartTrackKind] ?? [],
    );

    return tracks.map((chartTrack: ProChartTrack): ChartTrackPerGenreBucket => {
        const { work_title, music_user_genre_name_contributions } = chartTrack;

        const musicUserGenreNameContributions =
            music_user_genre_name_contributions === null
                ? []
                : music_user_genre_name_contributions;

        const genreBucket = genreMatchesFilter(chartTrackKind, 'digital')
            ? 'digital'
            : 'broadcast';

        const data: ChartTrackPerGenreBucket = {
            collaborator_earnings: 0,
            collaborator_percent_share: 0,
            earnings: 0,
            music_user_genre_name: genreBucket,
            percent_share: chartTrack.percent_share ?? 0,
            work_title,
            splits_total_earnings: 0,
        };

        musicUserGenreNameContributions.forEach(
            ({
                music_user_genre_name,
                earnings_contribution,
            }: ProMusicUserGenreNameContribution): void => {
                if (
                    music_user_genre_name !== null &&
                    earnings_contribution !== null &&
                    earnings_contribution !== undefined
                ) {
                    if (
                        genreMatchesFilter(music_user_genre_name, genreBucket)
                    ) {
                        data.earnings += earnings_contribution;
                    }
                }
            },
        );

        const splits = calculateTrackSplits(data);

        data.collaborator_earnings = splits.collaborator_earnings;
        data.collaborator_percent_share = splits.collaborator_percent_share;
        data.splits_total_earnings = splits.total_earnings;

        return data;
    });
};

/**
 * Map a ProChartTrack array to an array of track data that are separated by "genre bucket". The
 * overall goal is to get an array of elements that can be filtered by 'broadcast / other' vs.
 * 'digital'. After this filtering, they should each represent the total earnings for a given track
 * within that genre bucket.
 * @param {ProChartTrack[]} chartTracks
 * @return {ChartTrackPerGenreBucket}
 */
export const mapChartTracksToGenreBuckets = (
    chartTracks: ProChartTrackWrapper | null,
): ChartTrackPerGenreBucket[] => {
    const digitalTracks = getChartTracksPerGenreBucket(chartTracks, 'digital');
    const nonDigitalTracks = getChartTracksPerGenreBucket(
        chartTracks,
        'nondigital',
    );
    const flatTracks = [...digitalTracks, ...nonDigitalTracks];

    return flatTracks;
};
